import { render, staticRenderFns } from "./serviceSet.vue?vue&type=template&id=33ea41c6&scoped=true&"
import script from "./serviceSet.vue?vue&type=script&lang=js&"
export * from "./serviceSet.vue?vue&type=script&lang=js&"
import style0 from "./serviceSet.vue?vue&type=style&index=0&id=33ea41c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ea41c6",
  null
  
)

export default component.exports